import React from "react";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const HtmlTooltip = styled(({ className, title, ...props }) => {
  // Remove title from props passed to children
  const { children, ...otherProps } = props;
  return (
    <Tooltip {...otherProps} classes={{ popper: className }} title={title}>
      {React.cloneElement(children, { title: undefined })}
    </Tooltip>
  );
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#616161eb",
    color: "#FFF",
    maxWidth: 320,
    marginTop: "5px !important",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

export default HtmlTooltip;
